import { StyleSheet } from 'aphrodite/no-important';
import { palettes, spacers } from '@trainline/depot-web/css';

export default StyleSheet.create({
  wrapper: {
    marginTop: spacers.dp_s32,
    marginBottom: spacers.dp_s32,
    display: 'flex',
    flexFlow: 'column',
  },
  header: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: `space-between`,
    flexGrow: 1,
    border: `1px solid ${palettes.dp_app_border_base}`,
    borderRadius: `${spacers.dp_s8} ${spacers.dp_s8} 0 0`,
    background: palettes.dp_app_backdrop_white,
    padding: `${spacers.dp_s8} ${spacers.dp_s12}`,
  },
});
